import { Box3Status, OctreeManager, Node } from "./OctreeManager";
import * as THREE from 'three';
import { ThreeView } from "../View3dWebCad";

type pointsType = {point: THREE.Vector3, isCheck: boolean, isResult: boolean };

export class CameraTarget {
    public box3Status: Box3Status[]; // 描画のために保持
    private frustum: THREE.Frustum;

    constructor() {
        this.frustum = new THREE.Frustum();
    }
    
    private _push = (_status: Node) => {
        for (let i = 0; i < _status.children.length; i++) {
            const child = _status.children[i];
            if (child.box3Status.length > 0) {
                this.box3Status.push(...child.box3Status);
            }

            if (child.children.length > 0) this._push(child); 
        }
    }
    
    // boxの８点を求める
    private boxPoints = (min: THREE.Vector3, max: THREE.Vector3): pointsType[] => {
        const p1 = { point: new THREE.Vector3(min.x, min.y, min.z), isCheck: false, isResult: false };
        const p2 = { point: new THREE.Vector3(max.x, min.y, min.z), isCheck: false, isResult: false };
        const p3 = { point: new THREE.Vector3(min.x, max.y, min.z), isCheck: false, isResult: false };
        const p4 = { point: new THREE.Vector3(min.x, min.y, max.z), isCheck: false, isResult: false };
        const p5 = { point: new THREE.Vector3(max.x, max.y, min.z), isCheck: false, isResult: false };
        const p6 = { point: new THREE.Vector3(min.x, max.y, max.z), isCheck: false, isResult: false };
        const p7 = { point: new THREE.Vector3(max.x, min.y, max.z), isCheck: false, isResult: false };
        const p8 = { point: new THREE.Vector3(max.x, max.y, max.z), isCheck: false, isResult: false };

        return [p1, p2, p3 ,p4, p5, p6, p7, p8];
    }

    // 計算した頂点がある場合は置き換え
    private boxPoints_ = (allPoints: pointsType[], points: pointsType[]): pointsType[] => {
        for (let l = 0; l < points.length; l++) {
            if (points[l].isCheck == false) continue;
            for (let k = 0; k < allPoints.length; k++) {
                if (points[l].point.equals(allPoints[k].point)) allPoints.splice(k, 1, points[l]);
            }
        }
        return allPoints;
    }

    public getTargets(camera: THREE.Camera, status: Node) {
        this.box3Status = [];

        camera.updateMatrix(); // make sure camera's local matrix is updated
        camera.updateMatrixWorld(); // make sure camera's world matrix is updated

        this.frustum.setFromProjectionMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
        
        // param _status: Node, _points: 計算した頂点を渡す
        const judge = (_status: Node, _points: pointsType[]) => {

            // 末端の場合
            if (_status.box3Status.length > 0) {
                this.box3Status.push(..._status.box3Status);
                // this.base(_status.box); // draw
                return;
            }
            
            const min = _status.box.min;
            const max = _status.box.max;
            let points = this.boxPoints(min, max);
            // 計算した頂点がある場合は置き換え
            if (_points.length > 0) points = this.boxPoints_(points, _points);

            let isIn = false;
            let isOut = false;
            for(let j = 0; j < points.length; j++) {

                if (points[j].isCheck) {
                    if (points[j].isResult) isIn = true;
                    else isOut = true;
                    continue;
                }

                points[j].isCheck = true;
                if (this.frustum.containsPoint(points[j].point)) {
                    if (j == points.length - 1) {
                        // boxの頂点が全て画角内に存在する場合
                        this._push(_status);
                        // this.base(_status.box); // draw
                        return;
                    }
                    isIn = true;
                    points[j].isResult = true;
                } else {
                    isOut = true;
                }

                if (isIn && isOut) break;
            }

            const checkIntersectBox = (num: number): boolean => (isIn && isOut) ? true : this.frustum.intersectsBox(_status.children[num].box);

            if (isIn && !isOut) return;
            for(let i = 0; i < _status.children.length; i++) {
                if (checkIntersectBox(i)) {
                    judge(_status.children[i], points);
                } 
            }
        }
        
        // this.removeBase(); // draw
        judge(status, []);

        this.box3Status = [...new Set(this.box3Status)];
        // this.frustrum(camera); // draw
    }

    private drawBox: THREE.Box3Helper[] = [];
    private drawBox_: THREE.Box3Helper[] = [];
    public draw(bbox: THREE.Box3) {
        const box = new THREE.Box3Helper( bbox, this.getColor() );
        this.drawBox.push( box );
        ThreeView.get().wcItemmgr.addOtherShapes(box);
    }

    public remove() {
        this.drawBox.forEach(box => {
            ThreeView.get().wcItemmgr.removeOtherShapes(box);
        });
        this.drawBox = [];
    }
    
    private getColor(): THREE.Color {
        const color = (Math.random() * 0xFFFFFF | 0).toString(16);
        const randomColor = "#" + ("000000" + color).slice(-6);
        return new THREE.Color(randomColor);
    }
    
    public frustrum(camera: THREE.Camera) {
        const helper = new THREE.CameraHelper( camera );
        ThreeView.get().wcItemmgr.addOtherShapes(helper);
        this.remove();
        this.box3Status.forEach((status: Box3Status) => {
            this.draw(status.box);
        });
        this.drawBox_.forEach((box) => {
            ThreeView.get().wcItemmgr.addOtherShapes(box);
        });
    }
    
    private removeBase() {
        this.drawBox_.forEach((box) => {
            ThreeView.get().wcItemmgr.removeOtherShapes(box);
        });
        this.drawBox_ = [];
    }
    private base(bbox: THREE.Box3) {
        const box = new THREE.Box3Helper( bbox, new THREE.Color('#000000'));
        this.drawBox_.push( box );
    }

}
